// @flow

import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import MonthPicker from 'common/components/monthlyDateRangePicker/MonthPicker';
import Month from 'common/components/monthlyDateRangePicker/Month';
import { getToken } from 'statsradio/modules/authentication/session/selectors/sessionSelectors';
import Page from 'statsradio/components/page/Page';
import { BroadcastMonth } from 'broadcastCalendar/BroadcastMonth';
import InvoicingAPI from './services/InvoicingAPI';
import RadioInvoices from './components/RadioInvoices';
import RadioCampaignInvoice from './domain/RadioCampaignInvoice';

const Actions = styled.div`
  display: flex;
  flex-direction: flow;
  padding-bottom: 16px;
`;

interface Props {
  token: string;
  t: any;
}

interface State {
  month: BroadcastMonth;
  radioInvoices: RadioCampaignInvoice[];
  fetching: boolean;
}

class InvoicingPage extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      fetching: false,
      radioInvoices: [],
      month: BroadcastMonth.now(),
    };
  }

  componentDidMount() {
    this.fetchInvoices();
  }

  fetchInvoices = async () => {
    const { month } = this.state;
    const { token } = this.props;

    if (!month) {
      return;
    }

    this.setState({ fetching: true });
    const invoices = await InvoicingAPI.getCampaignsInvoices(token, month);
    this.setState({ radioInvoices: invoices.radioInvoices, fetching: false });
  }

  onSelectMonth = (month: Month) => this.setState({ month: month.asBroadcastMonth() }, this.fetchInvoices);

  billInvoice = (invoice: RadioCampaignInvoice) => async (billed: boolean) => {
    const { token } = this.props;

    await InvoicingAPI.markInvoiceAsBilled(token, invoice, billed);
  }

  render() {
    const { fetching, radioInvoices, month } = this.state;
    const { t } = this.props;

    return (
      <Page title={t('pageTitle')} useThemeV2>
        <Actions className="row">
          <div className="col-xs-2">
            <MonthPicker
              selectedDate={Month.fromBroadcastMonth(month)}
              onSelectMonth={this.onSelectMonth}
            />
          </div>
        </Actions>
        <RadioInvoices t={t} fetching={fetching} radioInvoices={radioInvoices} onBilledChange={this.billInvoice} />
      </Page>
    );
  }
}

function mapStateToProps(state, ownProps: Props) {
  return {
    token: getToken(state),
  };
}

export default translate('invoicing')(connect(mapStateToProps)(InvoicingPage));



// WEBPACK FOOTER //
// ./src/statsradio/modules/billing/InvoicingPage.js